// components/OtherArticles.js
import React, { useEffect, useState } from 'react';
import { fetchMostViewedPosts } from '../../services/api'; // You need an API endpoint to fetch other posts

const OtherArticles = ({ currentSlug, currentLang, limit = 12 }) => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
  let interval;

  const getOtherPosts = async () => {
    try {
      const allPosts = await fetchMostViewedPosts(currentLang);
      const filtered = allPosts.filter(post => post.slug !== currentSlug);

      // Initial shuffle
      setPosts(shuffleArray(filtered).slice(0, limit));

      // Reshuffle every 5 seconds
      interval = setInterval(() => {
        setPosts(prevPosts => shuffleArray(filtered).slice(0, limit));
      }, 20000);

      setLoading(false);
    } catch (err) {
      console.error(err);
      setError('Failed to load other articles.');
      setLoading(false);
    }
  };

  getOtherPosts();

  return () => clearInterval(interval); // clean up
}, [currentSlug, currentLang, limit]);

// Simple shuffle function
const shuffleArray = (array) => [...array].sort(() => 0.5 - Math.random());



  if (loading) return <div className="text-center my-4">Loading other articles...</div>;
  if (error) return <div className="text-center my-4 text-danger">{error}</div>;
  if (!posts.length) return null;

  return (
    <div className="my-3">
  <h3 className="fw-bold text-center mb-4">You might also like</h3>
  <div className="row">
    {posts.map((post) => (
      <div key={post.slug} className="col-md-6 mb-3">
        <a
          href={`/posts/${post.slug}`}
          className="text-decoration-none text-dark"
          style={{ display: 'block' }}
        >
          <div className="card h-100 hover-card">
            {post.featured_image && (
              <img
                src={post.featured_image}
                className="card-img-top"
                alt={post.title}
                style={{ height: '120px', objectFit: 'cover' }}
              />
            )}
            <div className="card-body d-flex flex-column">
              <h5 className="fw-bold card-title text-center mb-2">{post.title}</h5>
              <p
                className="card-text"
                style={{
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  display: '-webkit-box',
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: 'vertical',
                }}
              >
                {post.excerpt}
              </p>
            </div>
          </div>
        </a>
      </div>
    ))}
  </div>
</div>

  );
};

export default OtherArticles;
